<div
  routerLink="/games"
  class="mini-games-banner group flex h-[30.2rem] w-[40.4rem] shrink-0 cursor-pointer overflow-hidden rounded-[2.4rem] bg-[linear-gradient(359deg,#2963D2_7.05%,#11379E_108.62%)] p-[2.4rem] custom-transition-bg before:bg-[linear-gradient(359deg,#407BED_7.05%,#214DC4_108.62%)] lg:h-[16.6rem] lg:w-full lg:rounded-[1.6rem] lg:p-[1.6rem]"
>
  <div class="z-[1] flex h-full flex-col justify-between">
    <div class="flex flex-col items-start space-y-[0.4rem]">
      <span
        i18n="@@main.minigames.title"
        class="text-[2rem] font-450 leading-[2.6rem] text-white lg:text-[1.5rem] lg:leading-[2.2rem]"
        >Мини Игры</span
      >
      <span
        i18n="@@main.minigames.desc"
        class="max-w-[16rem] text-[1.4rem] font-350 leading-[2rem] text-light-600 opacity-80 lg:max-w-[13rem] lg:text-[1.1rem] lg:leading-[1.4rem]"
        >Crash, Upgrade, Mines и многое другое</span
      >
    </div>
    <button
      class="flex h-[3rem] w-[5rem] items-center justify-center rounded-[1rem] bg-[#A5C6FF] opacity-80 custom-transition-all group-hover:w-[5.6rem] group-hover:bg-[#C6DBFF] lg:h-[2.6rem] lg:w-[3.8rem] lg:rounded-[0.8rem]"
    >
      <i class="icon icon_arrow-right-alt text-[2.4rem] !text-dark-250 lg:text-[1.8rem]"></i>
    </button>
  </div>
  <div class="mini-games-shadow"></div>
  <div class="mini-games-man"></div>
  <div class="mini-games-defuse"></div>
  <div class="mini-games-double"></div>
  <div class="mini-games-crash"></div>
  <div class="mini-games-mines"></div>
</div>
